var React = require('react');

function Copy (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M22.349,7H9.977A.977.977,0,0,0,9,7.977V23.6a.977.977,0,0,0,.977.977H22.349a.977.977,0,0,0,.977-.977V7.977A.977.977,0,0,0,22.349,7Zm-.326,16.279H10.3V8.3H22.023Z","transform":"translate(-5.744 -3.744)","fill":"#9a9a9a","key":0}),React.createElement("path",{"d":"M18.326,2.977A.977.977,0,0,0,17.349,2H4.977A.977.977,0,0,0,4,2.977V18.6a.977.977,0,0,0,.977.977H5.3V3.3H18.326Z","transform":"translate(-4 -2)","fill":"#9a9a9a","key":1})]);
}

Copy.defaultProps = {"width":"17.581","height":"20.837","viewBox":"0 0 17.581 20.837"};

module.exports = Copy;

Copy.default = Copy;
